// extracted by css-extract-rspack-plugin
export default {"errorLink":"_899145ed","body":"_5d577145","textWrapper":"_a94cdedb","footer":"_72131930"};